import { Navigate, generatePath, useLocation } from 'react-router';
import { useDefaultClient } from '../ClientsOverviewPage/contexts/useClientsOverview';
import { LoadingOverlay } from '@/Components/shared';
import { useUserContext } from '@/Context/UserContext';
import RoutePath from '@/Routing/RoutePath';
import withSignupChecks from '@/Routing/withSignupChecks';
import withTalentMeshUserRequired from '@/Routing/withTalentMeshUserRequired';

function RootPage() {
    const { isLoading, memberships, ownerCompany } = useUserContext();
    const { state } = useLocation();
    const { data: defaultClient, isLoading: isLoadingDefaultClient } = useDefaultClient(ownerCompany?.companyId);

    if (isLoading) {
        return <LoadingOverlay />;
    }

    // by default we log user into the first company
    const companyId = memberships[0]?.companyId;

    if (memberships.length === 0) {
        return <Navigate to={RoutePath.SetupAccount} />;
    }

    if (state?.skipToRecruitmentOverview) {
        if (isLoadingDefaultClient) {
            return <LoadingOverlay />;
        }

        return <Navigate to={generatePath(RoutePath.AssessmentsActive, { companyId, clientId: defaultClient?.id! })} />;
    }

    return <Navigate to={generatePath(RoutePath.CompanyRoot, { companyId })} />;
}

export default withTalentMeshUserRequired(withSignupChecks(RootPage));
